export const translationKeys = {
  title: "Postúlate como proveedor",
  subTitle1:
    "Para formar parte de nuestro equipo necesitamos que nos brindes datos sobre los servicios que prestas.",
  subTitle2:
    "Estaremos evaluando la información presentada y a la brevedad nos pondremos en contacto.",
};
